export default [
	{
		type: "q1answer",
		text: "Currently in high school"
	},
	{
		type: "q1answer",
		text: "Graduated from high school"
	},
	{
		type: "q1answer",
		text: "Some college/university"
	},
	{
		type: "q1answer",
		text: "A bachelor's degree"
	},
	{
		type: "q1answer",
		text: "An established career"
	},
	{
		type: "q2answer",
		text: "Design a better world",
		validFor: [
			{
				q1answer: "Currently in high school"
			},
			{
				q1answer: "Graduated from high school"
			},
			{
				q1answer: "Some college/university"
			},
			{
				q1answer: "An established career"
			},
			{
				q1answer: "A bachelor's degree"
			}
		]
	},
	{
		type: "q2answer",
		text: "Discover my creative passion",
		validFor: [
			{
				q1answer: "Currently in high school"
			},
			{
				q1answer: "Graduated from high school"
			},
			{
				q1answer: "Some college/university"
			}
		]
	},
	{
		type: "q2answer",
		text: "Be an exhibiting artist",
		validFor: [
			{
				q1answer: "Currently in high school"
			},
			{
				q1answer: "Graduated from high school"
			},
			{
				q1answer: "Some college/university"
			},
			{
				q1answer: "An established career"
			},
			{
				q1answer: "A bachelor's degree"
			}
		]
	},
	{
		type: "q2answer",
		text: "Solve problems through design",
		validFor: [
			{
				q1answer: "Currently in high school"
			},
			{
				q1answer: "Graduated from high school"
			},
			{
				q1answer: "Some college/university"
			},
			{
				q1answer: "An established career"
			},
			{
				q1answer: "A bachelor's degree"
			}
		]
	},
	{
		type: "q2answer",
		text: "Work in a museum or gallery",
		validFor: [
			{
				q1answer: "Currently in high school"
			},
			{
				q1answer: "Graduated from high school"
			},
			{
				q1answer: "Some college/university"
			},
			{
				q1answer: "An established career"
			},
			{
				q1answer: "A bachelor's degree"
			}
		]
	},
	{
		type: "q2answer",
		text: "Build games, apps and more",
		validFor: [
			{
				q1answer: "Currently in high school"
			},
			{
				q1answer: "Graduated from high school"
			},
			{
				q1answer: "Some college/university"
			},
			{
				q1answer: "An established career"
			},
			{
				q1answer: "A bachelor's degree"
			}
		]
	},
	{
		type: "q2answer",
		text: "Bring stories to life on screen",
		validFor: [
			{
				q1answer: "Currently in high school"
			},
			{
				q1answer: "Graduated from high school"
			},
			{
				q1answer: "Some college/university"
			},
			{
				q1answer: "An established career"
			},
			{
				q1answer: "A bachelor's degree"
			}
		]
	},
	{
		type: "q2answer",
		text: "Build the world of tomorrow",
		validFor: [
			{
				q1answer: "An established career"
			},
			{
				q1answer: "A bachelor's degree"
			}
		]
	},
	{
		type: "q2answer",
		text: "Teach the next generation",
		validFor: [
			{
				q1answer: "An established career"
			},
			{
				q1answer: "A bachelor's degree"
			}
		]
	},
	{
		type: "q2answer",
		text: "Research, create + critique scholarly work",
		validFor: [
			{
				q1answer: "An established career"
			},
			{
				q1answer: "A bachelor's degree"
			}
		]
	},
	{
		type: "q2answer",
		text: "Become an expert",
		validFor: [
			{
				q1answer: "An established career"
			},
			{
				q1answer: "A bachelor's degree"
			}
		]
	},
	{
		type: "program",
		text: "Design",
		id: "846633",
		validFor: [
			{
				q1answer: "Currently in high school",
				q2answer: "Design a better world"
			},
			{
				q1answer: "Graduated from high school",
				q2answer: "Design a better world"
			},
			{
				q1answer: "Some college/university",
				q2answer: "Design a better world"
			},
			{
				q1answer: "Currently in high school",
				q2answer: "Solve problems through design"
			},
			{
				q1answer: "Graduated from high school",
				q2answer: "Solve problems through design"
			},
			{
				q1answer: "Some college/university",
				q2answer: "Solve problems through design"
			}
		]
	},
	{
		type: "program",
		text: "Design",
		id: "870112",
		validFor: [
			{
				q1answer: "An established career",
				q2answer: "Design a better world"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Design a better world"
			},
			{
				q1answer: "An established career",
				q2answer: "Solve problems through design"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Solve problems through design"
			},
			{
				q1answer: "An established career",
				q2answer: "Build the world of tomorrow"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Build the world of tomorrow"
			}
		]
	},
	{
		type: "program",
		text: "Arts",
		id: "846636",
		validFor: [
			{
				q1answer: "Currently in high school",
				q2answer: "Be an exhibiting artist"
			},
			{
				q1answer: "Graduated from high school",
				q2answer: "Be an exhibiting artist"
			},
			{
				q1answer: "Some college/university",
				q2answer: "Be an exhibiting artist"
			},
			{
				q1answer: "Currently in high school",
				q2answer: "Work in a museum or gallery"
			},
			{
				q1answer: "Graduated from high school",
				q2answer: "Work in a museum or gallery"
			},
			{
				q1answer: "Some college/university",
				q2answer: "Work in a museum or gallery"
			}
		]
	},
	{
		type: "program",
		text: "Arts",
		id: "870138",
		validFor: [
			{
				q1answer: "An established career",
				q2answer: "Be an exhibiting artist"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Be an exhibiting artist"
			},
			{
				q1answer: "An established career",
				q2answer: "Build games, apps and more"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Build games, apps and more"
			},
			{
				q1answer: "An established career",
				q2answer: "Work in a museum or gallery"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Work in a museum or gallery"
			},
			{
				q1answer: "An established career",
				q2answer: "Bring stories to life on screen"
			}
		]
	},
	{
		type: "program",
		text: "Media Arts",
		id: "846639",
		validFor: [
			{
				q1answer: "Currently in high school",
				q2answer: "Build games, apps and more"
			},
			{
				q1answer: "Graduated from high school",
				q2answer: "Build games, apps and more"
			},
			{
				q1answer: "Some college/university",
				q2answer: "Build games, apps and more"
			},
			{
				q1answer: "Currently in high school",
				q2answer: "Bring stories to life on screen"
			},
			{
				q1answer: "Graduated from high school",
				q2answer: "Bring stories to life on screen"
			},
			{
				q1answer: "Some college/university",
				q2answer: "Bring stories to life on screen"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Bring stories to life on screen"
			}
		]
	},
	{
		type: "program",
		text: "Foundation Year",
		id: "846642",
		validFor: [
			{
				q1answer: "Currently in high school",
				q2answer: "Discover my creative passion"
			},
			{
				q1answer: "Graduated from high school",
				q2answer: "Discover my creative passion"
			},
			{
				q1answer: "Some college/university",
				q2answer: "Discover my creative passion"
			}
		]
	},
	{
		type: "program",
		text: "Graduate Studies",
		id: "846645",
		validFor: [
			{
				q1answer: "An established career",
				q2answer: "Teach the next generation"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Teach the next generation"
			},
			{
				q1answer: "An established career",
				q2answer: "Research, create + critique scholarly work"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Research, create + critique scholarly work"
			},
			{
				q1answer: "An established career",
				q2answer: "Become an expert"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Become an expert"
			}
		]
	},
	{
		type: "profile",
		text: "Pat Christie",
		id: "846648",
		validFor: [
			{
				q1answer: "Currently in high school",
				q2answer: "Design a better world"
			},
			{
				q1answer: "Currently in high school",
				q2answer: "Discover my creative passion"
			}
		]
	},
	{
		type: "profile",
		text: "Lisa Fraser",
		id: "846651",
		validFor: [
			{
				q1answer: "Graduated from high school",
				q2answer: "Design a better world"
			},
			{
				q1answer: "Some college/university",
				q2answer: "Design a better world"
			}
		]
	},
	{
		type: "profile",
		text: "Tsēmā Igharas",
		id: "846654",
		validFor: [
			{
				q1answer: "Currently in high school",
				q2answer: "Be an exhibiting artist"
			},
			{
				q1answer: "Currently in high school",
				q2answer: "Work in a museum or gallery"
			}
		]
	},
	{
		type: "profile",
		text: "Daina Warren",
		id: "846657",
		validFor: [
			{
				q1answer: "Graduated from high school",
				q2answer: "Be an exhibiting artist"
			},
			{
				q1answer: "Some college/university",
				q2answer: "Be an exhibiting artist"
			},
			{
				q1answer: "Graduated from high school",
				q2answer: "Work in a museum or gallery"
			},
			{
				q1answer: "Some college/university",
				q2answer: "Work in a museum or gallery"
			}
		]
	},
	{
		type: "profile",
		text: "Andrew Dadson",
		id: "846660",
		validFor: [
			{
				q1answer: "Currently in high school",
				q2answer: "Build games, apps and more"
			}
		]
	},
	{
		type: "profile",
		text: "Jay Grandin + Leah Nelson",
		id: "846663",
		validFor: [
			{
				q1answer: "Graduated from high school",
				q2answer: "Build games, apps and more"
			},
			{
				q1answer: "Some college/university",
				q2answer: "Build games, apps and more"
			}
		]
	},
	{
		type: "profile",
		text: "Diane Espiritu",
		id: "846666",
		validFor: [
			{
				q1answer: "Currently in high school",
				q2answer: "Solve problems through design"
			},
			{
				q1answer: "Graduated from high school",
				q2answer: "Discover my creative passion"
			},
			{
				q1answer: "Some college/university",
				q2answer: "Discover my creative passion"
			}
		]
	},
	{
		type: "profile",
		text: "Erin Boniferro",
		id: "846669",
		validFor: [
			{
				q1answer: "Graduated from high school",
				q2answer: "Solve problems through design"
			},
			{
				q1answer: "Some college/university",
				q2answer: "Solve problems through design"
			}
		]
	},
	{
		type: "profile",
		text: "Jason DaSilva",
		id: "846672",
		validFor: [
			{
				q1answer: "Currently in high school",
				q2answer: "Bring stories to life on screen"
			},
			{
				q1answer: "Graduated from high school",
				q2answer: "Bring stories to life on screen"
			},
			{
				q1answer: "Some college/university",
				q2answer: "Bring stories to life on screen"
			},
			{
				q1answer: "An established career",
				q2answer: "Build games, apps and more"
			},
			{
				q1answer: "An established career",
				q2answer: "Bring stories to life on screen"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Bring stories to life on screen"
			}
		]
	},
	{
		type: "profile",
		text: "Research",
		id: "846675",
		validFor: [
			{
				q1answer: "An established career",
				q2answer: "Design a better world"
			},
			{
				q1answer: "An established career",
				q2answer: "Solve problems through design"
			},
			{
				q1answer: "An established career",
				q2answer: "Work in a museum or gallery"
			},
			{
				q1answer: "An established career",
				q2answer: "Build the world of tomorrow"
			},
			{
				q1answer: "An established career",
				q2answer: "Teach the next generation"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Teach the next generation"
			},
			{
				q1answer: "An established career",
				q2answer: "Research, create + critique scholarly work"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Research, create + critique scholarly work"
			},
			{
				q1answer: "An established career",
				q2answer: "Become an expert"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Become an expert"
			}
		]
	},
	{
		type: "profile",
		text: "Grad Studies",
		id: "846678",
		validFor: [
			{
				q1answer: "A bachelor's degree",
				q2answer: "Design a better world"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Build games, apps and more"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Solve problems through design"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Work in a museum or gallery"
			},
			{
				q1answer: "A bachelor's degree",
				q2answer: "Build the world of tomorrow"
			}
		]
	},
	{
		type: "profile",
		text: "Luke Parnell",
		id: "846681",
		validFor: [
			{
				q1answer: "A bachelor's degree",
				q2answer: "Be an exhibiting artist"
			},
			{
				q1answer: "An established career",
				q2answer: "Be an exhibiting artist"
			}
		]
	}
]